<script setup lang="ts">
import { useGlobalStore } from '@/stores/globalStore.ts'
import { computed, onMounted } from 'vue'
import vi_VN from 'ant-design-vue/es/locale/vi_VN'
import dayjs from 'dayjs'
import 'dayjs/locale/vi'
import { setTheme } from '@/utils/setupDefaultSetting.ts'
import { setDeviceType } from '@/utils/device.ts'
import { useAuthStore } from '@/stores/authStore.ts'

dayjs.locale('en')

const isRefreshingToken = computed(() => {
  const { auth } = useAuthStore()
  return auth.isRefreshingToken
})

const loading = computed(() => {
  const globalStore = useGlobalStore()
  const {
    state: { loading }
  } = globalStore
  return loading
})

onMounted(() => {
  window.onresize = setDeviceType
  setDeviceType()
  setTheme()
})
</script>

<template>
  <div v-if="loading" class="h-screen flex flex-col items-center justify-center">
    <a-spin tip="Đang tải ..." />
  </div>
  <a-config-provider v-else :locale="vi_VN">
    <router-view v-slot="{ Component }">
      <div>
        <component :is="Component" />
      </div>
    </router-view>
  </a-config-provider>
  <div v-if="isRefreshingToken" class="global-loading-overlay">
    <a-spin size="large" tip="Đang làm mới phiên đăng nhập..." />
  </div>
</template>

<style scoped>
.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(2px);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
